import { supabase } from '../../../Utilities/SupabaseClient';
import getAssessmentTitle from '../../SupplierPage/Utilities/getAssessmentTitle';
import getSupplierInfoFromDB from '../../SupplierPage/Utilities/getSupplierInfoFromDB';
import getResponseCompletionDateFromDB from './getResponseCompletionDateFromDB';

// This function gets the received assessment responses from the DB.
const getResponseListFromDB = async (
	userid,
	page,
	pageSize,
	sortField,
	sortDirection
) => {
	try {
		const start = page * pageSize;
		const end = start + pageSize - 1;

		const { data, error, count } = await supabase
			.from('assessments_sent')
			.select('assessment_number, assessment_uuid, supplier_uuid', {
				count: 'exact',
			}) // Get total count for pagination
			.eq('response', true)
			.eq('sending_user_id', userid)
			.order(sortField, { ascending: sortDirection === 'asc' })
			.range(start, end);            
      
		if (error) throw error;

		// Fetch all completion dates in a single batch query
		const completionDates = await getResponseCompletionDateFromDB(data, page, pageSize);
		// Fetch supplier names & assessment titles in parallel
		const [supplierInfos, assessmentNames] = await Promise.all([
			Promise.all(
				data.map(({ supplier_uuid }) => getSupplierInfoFromDB(supplier_uuid))
			),
			Promise.all(
				data.map(({ assessment_number }) =>
					getAssessmentTitle(assessment_number)
				)
			),
		]);    

		const cleanedData = data
			.map((item, index) => {        
        const dateCompletedObj = completionDates?.completionDatesArray?.find(
          (completionItem) => completionItem.assessment_uuid === item.assessment_uuid
        );

        const dateCompleted = dateCompletedObj?.created_at; 
        
				if (!dateCompleted) return null;

				return {
					id: index + 1,
					company_name: supplierInfos[index]['company_name'],
					assessment_name: assessmentNames[index],
					email: supplierInfos[index]['email'],
					created_at: new Intl.DateTimeFormat('en-US', {
						year: 'numeric',
						month: 'short',
						day: 'numeric',
					}).format(new Date(dateCompleted)),
					contact_name: `${supplierInfos[index]['contact_first_name']} ${supplierInfos[index]['contact_last_name']}`,
					response_page: `/response/${item.assessment_uuid}`,
				};
			})
			.filter((item) => item !== null);

		return { cleanedData, count, pageSize };
	} catch (e) {
		console.log(e);
		throw e;
	}
};

export default getResponseListFromDB;
